module.exports = __webpack_public_path__ + "static/i-will-teach-you-to-be-rich-795c3e6cd28d7942fc8153e23678a66b.jpg";